export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/lensOrangeIcon.a8cc39ce.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};